export const API_PROJECTS_FIRST_TYPE_FIELDS = [
    'project_first_type.id',
    'project_first_type.status',
    'project_first_type.sort',
    'project_first_type.data_section',
    'project_first_type.formation_section',
    'project_first_type.results_impacts_section',
    'project_first_type.last_section_first_type',
    'project_first_type.publications_section',
    'project_first_type.financial_inclusion_section'
];
